module.exports = __webpack_public_path__ + "static/media/plan-C5-desktop-tc.7d4273eb.png";